import { Controller } from '@hotwired/stimulus'

// Controls which related-entity fields are visible for each has_many row in the
// AcademyPost admin form.
export default class extends Controller {
  static values = {
    linkOption: { type: String, default: '__link__' }
  }

  connect() {
    this.boundOnChange = this.onChange.bind(this)
    this.element.addEventListener('change', this.boundOnChange)
    this.setupObserver()
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener('change', this.boundOnChange)
    if (this.observer) this.observer.disconnect()
  }

  onChange(event) {
    if (!this.isTargetTypeSelect(event.target)) return
    this.updateForSelect(event.target)
  }

  setupObserver() {
    if (!window.MutationObserver) return

    this.observer = new MutationObserver(() => this.refresh())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  refresh() {
    const selects = this.targetTypeSelects()
    selects.forEach((select) => this.updateForSelect(select))
  }

  targetTypeSelects() {
    return Array.from(this.element.querySelectorAll('select[name$="[target_type]"]'))
  }

  isTargetTypeSelect(element) {
    if (!element || element.tagName !== 'SELECT') return false
    const name = element.name || ''
    return /\[target_type\]$/.test(name) || /(^|\W)target_type$/.test(name)
  }

  updateForSelect(select, container = null) {
    if (!select) return

    const selectedValue = select.value || ''
    const isLink = selectedValue === this.linkOptionValue
    container = container || select.closest('[data-controller~="entity-selector"]') || this.element
    this.toggleObjectWrappers(container, selectedValue, isLink)
    this.toggleLinkFields(container, isLink)
  }

  toggleObjectWrappers(container, selectedValue, isLink) {
    const wrappers = container.querySelectorAll('[data-related-type]')

    wrappers.forEach((wrapper) => {
      const controls = wrapper.querySelectorAll('select, input, textarea')
      const wrapperType = String(wrapper.dataset.relatedType || '').toLowerCase()
      const sel = String(selectedValue || '').toLowerCase()
      const simpleSel = sel.replace(/.*::/, '')
      const stripPlural = (s) => s.replace(/s$/, '')
      const matches = !isLink && (
        wrapperType === sel ||
        wrapperType === simpleSel ||
        stripPlural(wrapperType) === stripPlural(simpleSel) ||
        stripPlural(wrapperType) === simpleSel ||
        wrapperType === stripPlural(simpleSel)
      )

      if (matches) {
        wrapper.style.display = ''
        wrapper.classList.remove('d-none')
      } else {
        wrapper.classList.add('d-none')
        wrapper.style.display = 'none'
      }

      controls.forEach((control) => {
        control.disabled = !matches

        if (!matches) {
          if (control.tagName === 'SELECT') {
            control.selectedIndex = 0
          } else if ('value' in control) {
            control.value = ''
          }
        }
      })
    })
  }

  toggleLinkFields(container, isLink) {
    console.debug('EntitySelectorController.toggleLinkFields', { container, isLink })

    const linkText = container.querySelector('[data-entity-selector-target="linkText"]')
    const linkUrl = container.querySelector('[data-entity-selector-target="linkUrl"]')

    const setField = (el) => {
      if (!el) return
      // Prefer toggling the wrapper <li> that Formtastic generates so the
      // whole labelled input becomes visible. Fallback to toggling the input
      // itself if no wrapper is found.
      const wrapper = el.closest('li') || el.parentElement
      if (wrapper && wrapper.style) wrapper.style.display = isLink ? '' : 'none'

      el.disabled = !isLink
      if (!isLink && 'value' in el) el.value = ''
    }

    setField(linkText)
    setField(linkUrl)
  }
}
